module.exports = __webpack_public_path__ + "img/1584074485.ccc7c037.jpg";